import React from 'react';
import "../css/insurancesupport.css";
import { FiZap, FiUser, FiBookOpen, FiPhone, FiInfo } from 'react-icons/fi';
import { Helmet } from 'react-helmet-async';

const InsuranceSupport = () => {
    return (
        <div className="insurancesupport-container">
            <Helmet>
                <title>Policy Consultation | Expert Insurance Guidance & Advice India</title>
                <meta
                    name="description"
                    content="Get expert policy consultation and insurance guidance from Policy Samjho. We provide personalized insurance recommendations and clear policy explanations in India."
                />
                <meta 
                    name="keywords" 
                    content="policy consultation, insurance guidance, insurance expert advice, personalized insurance recommendations India, insurance policy explanation, insurance advice India, understand insurance policy" 
                />
                <link rel="canonical" href="https://policysamjho.com/insurance-support" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Policy Consultation & Insurance Guidance",
                        "description": "Get clear and simple insurance guidance from Policy Samjho. Personalized insurance advice in India to help you understand your insurance policy and avoid mistakes.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Policy Samjho",
                            "url": "https://policysamjho.com"
                        },
                        "serviceType": "Insurance Guidance & Consultation",
                        "areaServed": "IN",
                        "url": "https://policysamjho.com/insurance-support",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91-9584484800",
                            "email": "info@policysamjho.com",
                            "contactType": "customer service"
                        }
                    })}
                </script>
            </Helmet>

            <div className="insurancesupport-top-section">
                <div className="insurancesupport-left-panel">
                    <div className="insurancesupport-panel-header">
                        <div className="insurancesupport-header-icon">
                            <FiInfo size={30} color="#000E29" />
                        </div>
                        <h1 className="insurancesupport-panel-title">Expert Insurance Guidance & Policy Consultation</h1>
                        <p className="insurancesupport-panel-subtitle">
                            Personalized insurance advice in India to ensure your protection is built on clarity, not guesswork.
                        </p>
                    </div>
                    <div className="insurancesupport-contact-info">
                        <div className="insurancesupport-phone-wrapper">
                            <FiPhone size={18} color="#ffffff" className="insurancesupport-phone-icon" />
                            <span className="insurancesupport-phone-number">18005703990</span>
                        </div>
                        <span className="insurancesupport-call-to-action">Call to Our Experts</span>
                    </div>
                </div>
                <div className="insurancesupport-right-panel">
                    <div className="insurancesupport-feature-item">
                        <div className="insurancesupport-feature-icon">
                            <FiZap size={20} color="#F5A526" />
                        </div>
                        <div className="insurancesupport-feature-content">
                            <h3 className="insurancesupport-feature-title">Insurance Policy Explanation</h3>
                            <p className="insurancesupport-feature-description">
                                Get simplified, jargon-free explanations of any policy. We help you understand insurance policy terms without the legalese.
                            </p>
                        </div>
                    </div>
                    <div className="insurancesupport-feature-item">
                        <div className="insurancesupport-feature-icon">
                            <FiUser size={20} color="#F5A526" />
                        </div>
                        <div className="insurancesupport-feature-content">
                            <h3 className="insurancesupport-feature-title">Personalized Recommendations</h3>
                            <p className="insurancesupport-feature-description">
                                Book a session with an insurance expert for personalized insurance recommendations tailored to your specific financial needs.
                            </p>
                        </div>
                    </div>
                    <div className="insurancesupport-feature-item">
                        <div className="insurancesupport-feature-icon">
                            <FiBookOpen size={20} color="#F5A526" />
                        </div>
                        <div className="insurancesupport-feature-content">
                            <h3 className="insurancesupport-feature-title">Clarity in Insurance</h3>
                            <p className="insurancesupport-feature-description">
                                Use our tools to compare insurance policies and access guides that highlight insurance policy mistakes to avoid.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="insurancesupport-bottom-section">
                <div className="insurancesupport-bottom-text">We Provide Total Insurance Policy Help</div>
                <div className="insurancesupport-bottom-contact">
                    <div className="insurancesupport-bottom-phone-wrapper">
                        <FiPhone size={16} color="#ffffff" className="insurancesupport-bottom-phone-icon" />
                        <span className="insurancesupport-bottom-phone-number">18005703990</span>
                    </div>
                    <span className="insurancesupport-bottom-call-to-action">Call to Our Experts</span>
                </div>
            </div>
        </div>
    );
};

export default InsuranceSupport;